// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"a6ac217d","774":"8be49504"}[chunkId] + ".chunk.js";
};